<button class="syn-close-dialog" mat-icon-button (click)="cancel()">
    <mat-icon svgIcon="close"></mat-icon>
</button>

<h2 mat-dialog-title>
    {{ data.title }}
</h2>

<mat-dialog-content style="white-space: pre-line;" fxlayoutAlign="center center">
    {{ data.content }}
</mat-dialog-content>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end" fxLayoutGap="5px">
    <button mat-button (click)="cancel()">{{data.cancelText || 'Non'}}</button>
    <button mat-button (click)="confirm()">{{data.confirmText || 'Oui'}}</button>
</div>
